// extracted by mini-css-extract-plugin
export default {"content":"productPageLayout_content__S5ZxY"};